import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Fishermans Bend – Water Recycling Plant</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We'll design and construct a Water Recycling Plant (WRP) in Fishermans Bend to mine sewage from the Hobsons Bay Sewer Main and treat it to class A recycled water standard. 
        </p>
        <p>
          We’re planning for the future by investing in alternative water schemes to make our communities more resilient to climate change and conserve our precious drinking water supplies. 
        </p>
        <p>
          The WRP site will be located just off Sardine Street within the Fishermans Bend Employment precinct. 
        </p>
        <p>
          For more project information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/projects/fishermans-bend/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend - Water Recycling Plant',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800055465">1800 055 465</a> |{' '}
          <a
            href="mailto:FishermansBend@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: FishermansBend@sew.com.au - Fishermans Bend - Water Recycling Plant',
              });
            }}
          >
            FishermansBend@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
